import DoProgressBar from './DoProgressBar';

/* istanbul ignore next */
DoProgressBar.install = function (Vue) {
    Vue.component(DoProgressBar.name, DoProgressBar);
};

export default DoProgressBar;